import React, { ComponentProps } from "react";

export const ExternalLink = ({ children, ...props }: ComponentProps<"a">) => {
  return <a {...props}>{children}</a>;
};
